<template>
    <div class="view-container">
      <modal :showDialog="selectedRow != null" @close="closeModal" :maxWidth="'50vw'" :title="selectedRow!= null ? questions.find(x => x.id == selectedRow.dataId).description : null">
        <div class="m-4">
          <div style="font-weight: bold;" class="mb-1">
             {{ selectedRow != null ? questions.find(x => x.id == selectedRow.dataId).description : null }}
          </div>
          <div style="white-space: pre-line;">
            {{ selectedRow != null ? questions.find(x => x.id == selectedRow.dataId).conditions : null }}
          </div>
        </div>
      </modal>
      <div style="width: 100%; height: 100%; overflow-x: auto">
        <div class="max-grid">
          <ejs-grid ref="grid" height='100%' width='100%' :toolbar="toolbar" :rowSelected="rowSelected" :rowDeselected="rowDeselected" :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="questions" :allowPaging="false" :allowFiltering='false' :allowSorting='true' :allowMultiSorting='true' :showBusyIndicator="true" :allowGrouping='true' :groupSettings='groupOptions'>
            <e-columns>
              <e-column field='id' :headerText="$t('NUMBER')" textAlign='Left' :customAttributes="customAttributes" ></e-column>
              <e-column field='description' :headerText="$t('DESCRIPTION')" textAlign='Left' :customAttributes="customAttributes"></e-column>
              <e-column v-if="$store.getters.isAdmin" field="sendToMobile" :headerText="$t('SEND_TO_MOBILE')" :template="mobileTemplate" :allowFiltering="false" :allowSorting="false" textAlign="Center"></e-column>
              <e-column :visible="false" field='priorityText' :headerText="$t('PRIORITY')" textAlign='Left' :customAttributes="customAttributes"></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
</template>

<script>
import { Sort, Filter, Toolbar, Search, CommandColumn, Page } from '@syncfusion/ej2-vue-grids';
import Modal from '../components/Modal.vue';
import { getAllAlarmTypesFaq, updateSendToMobileStatus } from '@api'
import VueToggles from 'vue-toggles';
import Vue from "vue";

export let context = null

export default {
    props: {},
    components: {
        Modal,
        VueToggles
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn ]
    },
    data() {
        return {
            selectedRow: null,
            questions: [],
			      selectedQuestion: null,

            toolbar:[
                'Search'
            ],
            filterOptions: {
                type: 'Menu'
            },
            wrapSettings: { wrapMode: 'Content' } ,
            selectionOptions: { type: 'Single' },
            customAttributes : {class: 'customcss'},
            groupOptions: { columns: ['priorityText'] },
            mobileTemplate: function() {
              return {
                template: Vue.component('mobileTemplate', {
                  template: `<div class="horizontal" style="justify-content: center;">
                    <VueToggles @click="clicked" :value="data.sendToMobile" checkedBg="#0095b2" uncheckedBg="lightgrey"></VueToggles>
                  </div>`,
                  components: {
                    VueToggles
                  },
                  data: function() {
                    return {
                      data: {}
                    }
                  },
                  methods: {
                    clicked() {
                      this.data.sendToMobile = !this.data.sendToMobile;
                      context.updateSendToMobile(this.data.id, this.data.sendToMobile);
                    }
                  }
                })
              }
            }
        }
    },
    methods: {
        async getData(){
            this.$store.dispatch('set_loading', true)
            this.questions = await getAllAlarmTypesFaq()
            this.questions.forEach(el => {
              el.description = this.$t(el.description)
            })
            this.questions.forEach(el => {
                el.priorityText = [this.$t('HIGH'), this.$t('MID'), this.$t('LOW')][el.priority - 1]
            })
            this.questions = this.questions.sort((a, b) => (a.priority - b.priority))
            this.$store.dispatch('set_loading', false)
        },
        // rowClick(index) {
        //     if(this.selectedRow !== index) {
        //         this.selectedRow = index;
        //     } else {
        //         this.selectedRow = null;
        //     }
        // },
        rowClass(index) {
            return this.selectedRow === index ? 'selected py-4' : ''
        },
        toolbarClick: function(args) {
            switch(args.item.id){

            }
        },
        dataBound: function() {
            this.$refs.grid.autoFitColumns();
        },
        rowSelected: function(row) {
          if (row.target.tagName != "SPAN") {
            this.selectedRow = {rowindex: row.rowIndex, dataId: row.data.id};
          } else {
            this.$refs.grid.clearSelection();
          }
        },
        rowDeselected(row) {
            this.selectedRow = null
            // this.selectedRow = row.
        },
        closeModal() {
            this.selectedRow = null
            this.$refs.grid.clearSelection();
        },
        async updateSendToMobile(id, value) {
          await updateSendToMobileStatus(id, value);
          var index = this.questions.findIndex(x => x.id == id)
          this.questions[index].sendToMobile = value;
        }
    },
    mounted: async function () {
    	this.getData();

      context = this;
    },
}
</script>

<style scoped>

.table {
    border-top: none;
    border-left: none;
    border-right: none;
}
.table tbody{
    border-left: 1px solid #A3D4E0;
    border-right: 1px solid #A3D4E0;
}
.e-grid .e-headercell.customcss{
    padding:0 5px 0 5px;
}
.e-grid .e-headercell .e-headercelldiv{
    padding-right:5px;
}
.e-gridchkbox.customcss .e-checkbox-wrapper{
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/Faq.vue